export const CONTACT_TIMEOUT_MS=15*60*1000;
const stamp=value=>{const n=typeof value==='number'?value:Date.parse(value??'');return Number.isFinite(n)&&n>0?n:null;};

// A declared pause suppresses contact alerts. After it ends, allow one normal
// contact window from the end of the pause, rather than declaring a fault at once.
export function contactState(lastSeenAt,policy={},now=Date.now()){
 const contactAt=stamp(lastSeenAt),pauseUntil=stamp(policy.sleepUntil);
 const sleeping=pauseUntil!==null&&pauseUntil>now;
 const interval=policy.contactSeconds;
 const expectedTimeout=typeof interval==='number'&&Number.isFinite(interval)&&interval>0?interval*3000:CONTACT_TIMEOUT_MS;
 const minimum=Number.isFinite(policy.minimumContactTimeoutMs)&&policy.minimumContactTimeoutMs>0?policy.minimumContactTimeoutMs:0;
 const timeoutMs=Math.max(expectedTimeout,minimum);
 const known=contactAt!==null&&contactAt<=now+1000;
 const expectedFrom=known?Math.max(contactAt,pauseUntil!==null&&!sleeping?pauseUntil:contactAt):null;
 const late=known&&!sleeping&&now-expectedFrom>=timeoutMs;
 return {contactAt:known?contactAt:null,sleeping,late,waiting:known&&!sleeping&&!late,timeoutMs};
}
